import { env } from "."

/* Components */
import { Picture, Chip, Bet, Fold, Exchange } from '../components'

/* Fields */
const chips = [
    { value: 1, color: "#f44336" },
    { value: 5, color: "#8bc34a" },
    { value: 25, color: "#2196f3" },
    { value: 100, color: "#ff9800" },
    { value: 500, color: "#673ab7" },
    { value: 1000, color: "#222222" },
]


const ru = [
    {
        id: 1,
        title: 'Правила игры',
        text: 'Цель игры – в наборе покерной комбинации карт более сильной, чем у дилера. Для игры используется одна стандартная колода из 52-х карт. Игрок делает ставку Анте (Ante) в пределах минимума и максимума стола и получает 5 карт. У дилера тоже 5 карт, одна из них открыта. За столом может играть только один игрок. Игрок может играть на один бокс или два бокса равными ставками. Если игрок, посмотрев свои карты, отказывается от игры, ставка Анте проигрывает. За сумму, равную ставке Анте, игрок может обменять от двух до пяти карт или докупить шестую карту. После этого игрок принимает решение – продолжать игру или нет. Если игрок принял решение играть, то он должен поставить ставку, равную двум Анте. Если игрок принимает решение не играть (Пас) – теряет при этом ставку Анте. После того, как игроки приняли решение, дилер открывает свои карты. Если у дилера есть игра, он сравнивает ее с покерными комбинациями игроков. У дилера есть игра, если в его картах есть комбинация Туз – Король или выше. Если у дилера нет игры – оплачивается только ставка Анте 1:1. Если у игрока комбинация старше, чем у дилера, оплачивается только ставка Бет в соответствии с таблицей выплат. Кроме выигрышной комбинации в картах игрока может быть образована вторая комбинация, которая также оплачивается. Вторая комбинация должна включать в себя хотя бы одну карту, не входящую в основную комбинацию. При комбинации Стрит оплачивается Стрит и Пара, а не два Стрита. Туз-Король и пара не является двумя парами. Если игровая комбинация игрока ниже, чем у дилера, то его ставки Анте и Бет проигрывают.',
        content:
            <div className="rule-content">

                <p>
                    <b>J-ПОКЕР</b>
                    <br /><br />
                    Цель игры – в наборе покерной комбинации карт более сильной, чем у дилера.
                </p>

                <p>Для игры используется одна стандартная колода из 52-х карт.</p>

                <p>Игрок делает ставку Анте (Ante) в пределах минимума и максимума стола и получает 5 карт. У дилера тоже 5 карт, одна из них открыта.</p>

                <p>Перед каждой раздачей автоматически случайным образом выбирается карта, которая будет Джокером в данной раздаче. Также может выпасть карта «DOC» (Dealers Open Card), в этом случае Джокером будет являться открытая карта дилера.</p>

                <p>Джокер – карта, которая заменяет любую карту для максимального усиления комбинации. Исключением является комбинация, когда есть Пара и Джокер, в этом случае Джокер образует вторую пару с картой высшего достоинства. В комбинации «Флэш» Джокер заменяет младшую карту
                    Если в комбинации есть три одинаковые карты и одна из них Джокер, то это комбинация «Тройка».</p>

                <p>Если игрок, посмотрев свои карты, отказывается от игры, ставка Анте проигрывает.</p>

                <p>За сумму, равную ставке Анте, игрок может обменять одну карту.   За сумму равную двум ставкам Анте, игрок может обменять две карты, и соответственно за сумму равную трем ставкам Анте, игрок может обменять три карты.</p>

                <p>После этого игрок принимает решение – продолжать игру или нет.</p>

                <p>Если игрок принял решение играть, то он должен поставить ставку (Бет), равную двум Анте. Если игрок принимает решение не играть (Пас) – теряет при этом ставку Анте. После того, как игроки приняли решение, дилер открывает свои карты.</p>

                <p>Минимальная игра – Две Двойки.</p>

                <p>Если у дилера есть игра, он сравнивает ее с покерными комбинациями игроков. Если у дилера нет игры – оплачивается только ставка Анте 1:1. Если у игрока комбинация старше, чем у дилера, оплачивается ставка Анте 1:1 и ставка Бет в соответствии с таблицей выплат.</p>

                <p>Если игровая комбинация игрока ниже, чем у дилера, то его ставки Анте и Бет проигрывают.</p>

                <p>Максимальная выплата – сумма, которая может быть выплачена на комбинацию.</p>

                <p>Таблица выплат</p>
                <table className="rules-table">
                    <tbody>
                        <tr>
                            <td>Пара</td>
                            <td>1:1</td>
                        </tr>
                        <tr>
                            <td>Две пары</td>
                            <td>2:1</td>
                        </tr>
                        <tr>
                            <td>Тройка</td>
                            <td>3:1</td>
                        </tr>
                        <tr>
                            <td>Стрит</td>
                            <td>4:1</td>
                        </tr>
                        <tr>
                            <td>Флеш</td>
                            <td>5:1</td>
                        </tr>
                        <tr>
                            <td>Фулл хаус</td>
                            <td>7:1</td>
                        </tr>
                        <tr>
                            <td>Каре</td>
                            <td>15:1</td>
                        </tr>
                        <tr>
                            <td>Стрит флеш</td>
                            <td>35:1</td>
                        </tr>
                        <tr>
                            <td>Роял флеш</td>
                            <td>75:1</td>
                        </tr>
                        <tr>
                            <td>Покер</td>
                            <td>150:1</td>
                        </tr>
                    </tbody>
                </table>

                <p>В случае совпадения комбинаций победитель определяется по старшей карте в покерной комбинации, а далее по следующим старшим картам. В комбинации «стрейт» 5-4-3-2-А туз являтся младшей картой.</p>

                <p>При полном совпадении всех карт в комбинации – «Stand off» (ничья).</p>
            </div>
    },
    {
        id: 2,
        title: 'Покерные комбинации',
        content:
            <div className="rule-content">

                <p>- Отдельные карты перечислены по убыванию: туз (старший или младший), король, дама, валет, 10, 9, 8, 7, 6, 5, 4, 3 и 2.
                    Туз может быть самой старшей картой в стрейте из туза, короля, дамы, валета и 10 или самой младшей в стрейте из 5, 4, 3, 2 и туза.
                    Возможные комбинации в порядке убывания:</p>

                <p>Покер - это комбинация, в состав которой входит четыре карты одного достоинство и джокер.</p>
                <div className="rules-combinations">
                    <div className="rules-combination">
                        <div className="rules-combination-text">5</div>
                        <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">5</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">5</div>
                        <Picture src={`${env.mediapoint}/images/suits/diamond.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">5</div>
                        <Picture src={`${env.mediapoint}/images/suits/clubs.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">+ Джокер</div>
                    </div>
                </div>

                <p>Флеш-рояль - это стрейт-флеш из туза, короля, дамы, валета и 10 одной масти.</p>
                <div className="rules-combinations">
                    <div className="rules-combination">
                        <div className="rules-combination-text">10</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">J</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">Q</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">K</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">A</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                </div>

                <p>Стрейт-флеш - это комбинация, в состав которой входит пять последовательных карт одной масти; например: десятка ,девятка, восьмерка, семерка и шестерка, все червовой масти. Два стрейт-флеша сравниваются по самой старшей карте в каждом из них.</p>
                <div className="rules-combinations">
                    <div className="rules-combination">
                        <div className="rules-combination-text">6</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">7</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">8</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">9</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">10</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                </div>


                <p>
                    Каре - это комбинация, в состав которой входит четыре карты одного достоинство и любая другая
                    карта. Например, четыре четверки в руке. Каре из карт более высокого
                    достоинства старше КАРЕ из карт более низкого достоинства.
                </p>
                <div className="rules-combinations">
                    <div className="rules-combination">
                        <div className="rules-combination-text">4</div>
                        <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">4</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">4</div>
                        <Picture src={`${env.mediapoint}/images/suits/diamond.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">4</div>
                        <Picture src={`${env.mediapoint}/images/suits/clubs.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">A</div>
                        <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Heart" />
                    </div>
                </div>


                <p>
                    Фулл-хаус - это комбинация, в состав которой входят три карты
                    одинакового достоинства и пара из карт другого достоинства, например: три
                    короля и две двойки. Из двух рук с фулл-хаусом старшей является та, в состав
                    которой входят три карты более высокого достоинства.
                </p>

                <div className="rules-combinations">
                    <div className="rules-combination">
                        <div className="rules-combination-text">K</div>
                        <Picture src={`${env.mediapoint}/images/suits/diamond.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">K</div>
                        <Picture src={`${env.mediapoint}/images/suits/clubs.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">K</div>
                        <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">2</div>
                        <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">2</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                </div>

                <p>
                    Флеш - это комбинация, в состав которой входят любые пять карт одной масти в любой
                    последовательности, например: пять карт червовой масти. Два флеша сравниваются
                    как руки со старшей картой; для определения победителя сравнивается самая старшая
                    карта в каждой из рук. Если в обеих руках совпадают карты самого высокого достоинства,
                    сравнивается вторая самая высокая по достоинству карта. И так до тех пор, пока не будет
                    определен победитель. Если все карты одного достоинства - НИЧЬЯ.
                </p>
                <div className="rules-combinations">
                    <div className="rules-combination">
                        <div className="rules-combination-text">3</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">6</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">9</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">10</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">Q</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                </div>

                <p>
                    Стрейт - это комбинация, в состав которой входят пять последовательных карт
                    разных мастей, например: Туз, двойка, тройка, чертверка и пятерка двух
                    или более мастей. Два стрейта сравниваются по самой старшей карте в каждой из рук.
                    Два стрейта с одинаковыми старшими картами имеют одинаковую ценность,
                    поскольку масти в сравнении не участвуют.
                </p>
                <div className="rules-combinations">
                    <div className="rules-combination">
                        <div className="rules-combination-text">A</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">2</div>
                        <Picture src={`${env.mediapoint}/images/suits/diamond.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">3</div>
                        <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">4</div>
                        <Picture src={`${env.mediapoint}/images/suits/clubs.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">5</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                </div>

                <p>
                    Тройка - это комбинация, в состав которой входят три карты одного достоинства и две неодинаковые
                    карты другого достоинства. Например, три ДАМЫ.
                </p>
                <div className="rules-combinations">
                    <div className="rules-combination">
                        <div className="rules-combination-text">Q</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">Q</div>
                        <Picture src={`${env.mediapoint}/images/suits/diamond.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">Q</div>
                        <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">2</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">10</div>
                        <Picture src={`${env.mediapoint}/images/suits/clubs.png`} alt="Heart" />
                    </div>
                </div>

                <p>Две пары - это комбинация, в состав которой входят две карты одного достоинства, две карты
                    другого достоинства (которые соответствуют друг другу, но не первой паре) и любая другая карта.
                </p>
                <p>
                    Например: ДВА ТУЗА и ДВА КОРОЛЯ. Для оценки
                    двух рук с двумя парами сначала сравнивается самая высокая пара каждой из рук.
                    Побеждает рука с самой высокой парой. Если в обеих руках имеется одинаковая по
                    величине самая высокая пара, сравнивается вторая пара каждой из рук. Если в обеих
                    руках имеются две равные пары, победитель определяется по следующей карте.
                </p>
                <div className="rules-combinations">
                    <div className="rules-combination">
                        <div className="rules-combination-text">A</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">A</div>
                        <Picture src={`${env.mediapoint}/images/suits/diamond.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">K</div>
                        <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">K</div>
                        <Picture src={`${env.mediapoint}/images/suits/clubs.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">3</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                </div>

                <p>
                    Пара - это комбинация, в состав которой входят две карты одного достоинствв (например: ДВА
                    КОРОЛЯ) и три неодинаковые карты другого достоинства.
                </p>

                <p>
                    Пара - эта самая слабая комбинация, которая может победить в игре. Пары из карт более
                    высокого достоинствв побеждают пары из карт более низкого достоинствв. Если в двух руках
                    имеется одинаковая пара, сравниваются следующие карты в порядке убывания.
                </p>

                <div className="rules-combinations">
                    <div className="rules-combination">
                        <div className="rules-combination-text">K</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">K</div>
                        <Picture src={`${env.mediapoint}/images/suits/diamond.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">3</div>
                        <Picture src={`${env.mediapoint}/images/suits/diamond.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">7</div>
                        <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">Q</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                </div>

                <p>
                    Туз Король – минимальная игра. Это рука, в которую входят Туз и Король и три
                    неодинаковые карты другого ранга.
                </p>
                <p>
                    Если в двух руках имеется Туз Король, сравниваются следующие карты в порядке
                    убывания.
                </p>

                <div className="rules-combinations">
                    <div className="rules-combination">
                        <div className="rules-combination-text">A</div>
                        <Picture src={`${env.mediapoint}/images/suits/clubs.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">K</div>
                        <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">3</div>
                        <Picture src={`${env.mediapoint}/images/suits/diamond.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">7</div>
                        <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">Q</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                </div>

            </div>
    },
    {
        id: 3,
        title: 'Бонус',
        type: 'bonus',
        content:
            <div className="rule-content">
                <p>Бонус – дополнительная ставка, которую может поставить игрок.</p>
                <p>Ставка Бонус выигрывает, если с первых пяти карт есть комбинация три одинаковых карты «Тройка» или выше и оплачивается в соответствии с таблицей выплат. В остальных случаях ставка на Бонус проигрывает.</p>
                <p>Таблица выплат</p>
                <table className="rules-table">
                    <tbody>
                        <tr>
                            <td>Тройка</td>
                            <td>10:1</td>
                        </tr>
                        <tr>
                            <td>Стрит</td>
                            <td>40:1</td>
                        </tr>
                        <tr>
                            <td>Флеш</td>
                            <td>50:1</td>
                        </tr>
                        <tr>
                            <td>Фулл хаус</td>
                            <td>70:1</td>
                        </tr>
                        <tr>
                            <td>Каре</td>
                            <td>200:1</td>
                        </tr>
                        <tr>
                            <td>Стрит флеш</td>
                            <td>1500:1</td>
                        </tr>
                        <tr>
                            <td>Роял флеш</td>
                            <td>5000:1</td>
                        </tr>
                    </tbody>
                </table>
            </div>
    },
    {
        id: 4,
        title: 'Делайте ставки',
        content:
            <div className="rule-content">

                <p>Панель «ЛИМИТЫ СТАВОК» отображает минимальные и максимальные разрешенные лимиты ставок за столом, которые могут время от времени меняться. Откройте «Лимиты ставок», чтобы проверить свои текущие лимиты.</p>

                <div className="rule-component">
                    <div className="game-info-inner">
                        <div className="game-info-text">J POKER</div>
                        <div className="game-info-rate">$ 1 - $ 1000</div>
                    </div>
                </div>

                <p>Для участия в игре вам потребуется достаточное количество средств, необходимое для покрытия ставок. Ваш текущий БАЛАНС отображается на экране.</p>
                <div className="rule-component">
                    <div className="balance-box">
                        <div className="balance-text">БАЛАНС:</div>
                        <div className="balance-value">$ 1 270</div>
                    </div>
                </div>

                <p>Индикатор «ОТОБРАЖЕНИЕ ФИШЕК» позволяет выбирать достоинство каждой фишки, которую захотите разместить в виде ставки. Для выбора доступны только те фишки, номинал которых может быть покрыт вашим текущим балансом.</p>
                <div className="rule-component">
                    <div className="chips-container" style={{ transform: 'scale(0.4)' }}>

                        <div className="chips-button">
                            <Picture src={`${env.mediapoint}/images/delete.png`} alt="Delete" />
                            Очистить
                        </div>

                        <div className="chips-button">
                            <Picture src={`${env.mediapoint}/images/cancel.png`} alt="Cancel" />
                            Отменить
                        </div>

                        <div className="chips-box">
                            {chips.map((chip, index) =>
                                <div key={`${index}`} className="chip">
                                    <Chip color={chip.color} value={chip.value} />
                                </div>
                            )}
                        </div>

                        <div className="chips-button">
                            <span>2x</span>
                            Удвоить
                        </div>

                        <div className="chips-button">
                            <Picture src={`${env.mediapoint}/images/refresh.png`} alt="Refresh" />
                            Повторить
                        </div>

                    </div>
                </div>


                <p>После выбора фишки сделайте ставку, нажав на соответствующее место для ставки на игровом столе. При каждом нажатии на место для ставок сумма вашей ставки увеличивается на стоимость выбранной фишки или до максимально допустимого лимита для выбранного вами типа ставки. После размещения максимально допустимого лимита ставки дополнительные средства не принимаются, а над вашей ставкой появится сообщение с уведомлением о размещении максимальной ставки.</p>
                <div className="rule-component">
                    <div className="rates" style={{ position: "relative", top: 0, bottom: 0 }} >
                        <div className="bonus">
                            <div style={{ zIndex: 1 }} className="bonus-text">BONUS</div>
                        </div>
                        <div className="ante">
                            <div className="ante-text" style={{ zIndex: 1 }}>ANTE</div>
                        </div>
                        <div className="bet" style={{ opacity: 1 }}>
                            <div className="ante-text" style={{ zIndex: 1 }}>BET</div>
                        </div>
                    </div>
                </div>

                <p>ПРИМЕЧАНИЕ: Пожалуйста, не сворачивайте окно браузера и не открывайте другие вкладки в своем браузере, пока активно время размещения ставок и ставки размещаются на столе. Такие действия могут быть расцедены как выход из игры, и, следовательно, ваши ставки будут отклонены в этом раунде игры.</p>

                <p>Кнопка «ПОВТОРИТЬ» позволяет повторить все ставки из предыдущего раунда игры. Эта кнопка остается активной до тех пор, пока не будет размещена первая фишка.</p>

                <div className="rule-component">
                    <div className="chips-button">
                        <Picture src={`${env.mediapoint}/images/refresh.png`} alt="Refresh" />
                        Повторить
                    </div>
                </div>

                <p>Кнопка «УДВОИТЬ» (2×) становится доступной после размещения ставки. С каждым щелчком/нажатием все ваши ставки удваиваются вплоть до максимального предела. Обратите внимание, что вам необходимо иметь достаточное количество средств на счете для удвоения ВСЕХ ваших размещенных ставок.</p>

                <div className="rule-component">
                    <div className="chips-button">
                        <span>2x</span>
                        Удвоить
                    </div>
                </div>

                <p>Кнопка «ОТМЕНА» позволяет удалить последнюю размещенную ставку.</p>
                <p>Повторное нажатие кнопки «ОТМЕНА» позволяет отменить ставки по одной в обратном порядке их размещения. Чтобы удалить все свои ставки, удерживайте нажатой кнопку «ОТМЕНА».</p>
                <div className="rule-component">
                    <div className="chips-button">
                        <Picture src={`${env.mediapoint}/images/cancel.png`} alt="Cancel" />
                        Отменить
                    </div>
                </div>

                <p>Кнопка «ОЧИСТИТЬ» позволяет удалить все размещенные ставки.</p>
                <div className="rule-component">
                    <div className="chips-button">
                        <Picture src={`${env.mediapoint}/images/delete.png`} alt="Delete" />
                        Очистить
                    </div>
                </div>

                <p>Индикатор «ОБЩАЯ СТАВКА» отображает общую сумму ставок, размещенных в текущем раунде.</p>
                <div className="rule-component">
                    <div className="balance-box">
                        <div className="balance-text blue">ОБЩЯЯ СТАВКА:</div>
                        <div className="balance-value">$ 270</div>
                    </div>
                </div>

                <p>Примите решение</p>
                <p>После раздачи ваших карт появится ваша комбинация карт и окно</p>
                <div className="rule-component">
                    <Picture src="/rules/game.png" alt="Game" />
                </div>

                <p>Для Обмена надо нажать на карты которые вы хотите поменять и нажать на окно ОБМЕНЯТЬ</p>
                <div className="rule-component">
                    <Exchange />
                </div>

                <p>Вы должны решить, что нажать: «BET» для продолжения раунда игры или «ПАС» для завершения раунда игры с потерей размещенных став</p>
                <div className="rule-component">
                    <Bet />
                    <Fold />
                </div>

                <p>При нажатии на кнопку «BET» вы продолжаете играть и делаете ставку «BET», Ставка «BET» будет автоматически размещена в месте для ставки «BET».</p>

                <p>После нажатия кнопки «ПАС» вы потеряете свою ставку АНТЕ.</p>
            </div>
    },
    {
        id: 5,
        title: 'Номер игры',
        content:
            <div className="rule-content">
                <p>Каждый раунд игры идентифицируется уникальным НОМЕРОМ ИГРЫ.</p>
                <div className="rule-component">
                    <p><b>#47489</b></p>
                </div>
                <p>Пожалуйста, используйте этот номер (или сделайте снимок экрана с номером игры), если вы хотите обратиться в Службу поддержки с вопросами относительно определенного раунда.</p>
            </div>
    },
    {
        id: 6,
        title: 'Звук',
        content:
            <div className="rule-content">
                <p>Кнопка «ЗВУК» включает/выключает все звуки игры и голоса. Примите к сведению, что в случае смены стола все звуки включатся автоматически.</p>

                <div className="rule-component">
                    <div className="game-control">
                        <Picture src={`${env.mediapoint}/images/music-on.png`} alt="Volume" />
                    </div>
                    <div className="game-control">
                        <Picture src={`${env.mediapoint}/images/volume.png`} alt="Volume" />
                    </div>
                </div>

                <p>Вы можете изменить настройки звука, нажав кнопку «НАСТРОЙКИ» и выбрав вкладку ЗВУК.</p>
            </div>
    },
    {
        id: 7,
        title: 'История игр',
        content:
            <div className="rule-content">
                <p>С помощью кнопки «ИСТОРИЯ» можно открыть окно, в котором будут отображены все сыгранные вами раунды игры и их результаты.</p>

                <div className="rule-component">
                    <div className="game-control">
                        <Picture src={`${env.mediapoint}/images/history.png`} alt="History" />
                    </div>
                </div>

                <p>Вы можете просматривать свою игровую активность с помощью следующего:</p>
                <p>• ИСТОРИЯ УЧЕТНОЙ ЗАПИСИ - отображает всю историю вашей учетной записи в виде списка дат, игр, сумм ставок и выплат.</p>
                <p>Последний завершенный раунд отображается в самом верху списка.</p>
                <p>• ИСТОРИЯ ИГР -- после щелчка/нажатия на определенную игру в столбце ИГРА отображает вашу историю, связанную с определенной игрой.</p>
            </div>
    },
    {
        id: 8,
        title: 'Действия в случае сбоя',
        content:
            <div className="rule-content">
                При сбоях в игре, игровой системе или процедуре игры раунд временно
                приостанавливается, а ведущий игры уведомляет об этом сервис-менеджера. Вы и
                другие игроки увидят сообщение в чате или всплывающее сообщение на экране о том,
                что данный вопрос рассматривается. Если менеджер сможет незамедлительно 2
                устранить ошибку, раунд игры продолжится, как обычно. В случае отсутствия
                возможности незамедлительного устранения раунд игры аннулируется, а изначальные
                ставки подлежат возмещению всем игрокам, принявшим в нем участие.            </div>
    },
    {
        id: 9,
        title: 'Политика отключения',
        content:
            <div className="rule-content">
                В случае отключения от игры до истечения времени для размещения ставок любые
                сделанные ставки признаются недействительными и возвращаются вам. В случае
                отключения после истечения времени для размещения ставок, сделанные ставки
                признаются действительными и разыгрываются без вашего участия. Результаты
                розыгрыша ставки можно посмотреть в окне «История» после повторного
                подключения.
            </div>
    }
]



const en = [
    {
        id: 1,
        title: 'Game Rules',
        text: "The goal of the game is to form a poker hand stronger than the dealer’s. A standard deck of 52 cards is used. The player places an Ante bet within the table’s minimum and maximum limits and receives 5 cards. The dealer also has 5 cards, one of which is face-up. Only one player can play at the table. The player can play on one or two boxes with equal bets. If the player, after seeing their cards, decides not to play, the Ante bet is lost. For an amount equal to the Ante bet, the player can exchange between two and five cards or purchase a sixth card. After this, the player decides whether to continue the game or not. If the player decides to play, they must place a bet equal to two Ante bets. If the player decides not to play (Fold), they lose the Ante bet. After the players make their decisions, the dealer reveals their cards. If the dealer has a qualifying hand, they compare it with the players’ poker hands. The dealer qualifies if their hand contains Ace-King or higher. If the dealer does not qualify, only the Ante bet is paid out at 1:1. If the player’s hand is stronger than the dealer’s, only the Bet is paid according to the payout table. In addition to the winning combination, the player’s cards may form a second combination, which is also paid. The second combination must include at least one card that is not part of the primary combination. For a Straight, both the Straight and the Pair are paid, but not two Straights. Ace-King and a pair do not count as two pairs. If the player's hand is lower than the dealer's, both the Ante and Bet bets are lost.",
        content:
            <div className="rule-content">

                <p>
                    <b>J-POKER</b>
                    <br /><br />
                    The goal of the game is to form a poker hand stronger than the dealer's.
                </p>

                <p>A standard deck of 52 cards is used for the game.</p>

                <p>The player places an Ante bet within the table's minimum and maximum limits and receives 5 cards. The dealer also receives 5 cards, with one card exposed.</p>

                <p>Before each hand, a card is randomly selected to act as the Joker for that hand. If the card "DOC" (Dealer's Open Card) is selected, the dealer's exposed card becomes the Joker.</p>

                <p>
                    The Joker is a card that substitutes for any other card to maximize the strength of the hand. Exceptions:
                    <ul>
                        <li>If the hand contains a Pair and a Joker, the Joker forms a second Pair with the highest-ranking card.</li>
                        <li>In the "Flash" combination, the Joker replaces the lowest card</li>
                        <li>If the hand contains three identical cards, and one is a Joker, the combination is considered "Three of a Kind."</li>
                    </ul>
                </p>

                <p>If the player, after viewing their cards, decides not to play, the Ante bet is lost.</p>

                <p>The player can exchange cards for the following costs:
                    <ul>
                        <li>1 card for the cost of the Ante bet.</li>
                        <li>2 cards for the cost of two Ante bets.</li>
                        <li>3 cards for the cost of three Ante bets.</li>
                    </ul>
                </p>

                <p>After this, the player decides whether to continue playing or not.</p>

                <p>If the player decides to play, they must place a Bet equal to twice the Ante. If the player decides not to play (Pass), they lose the Ante bet. After all players make their decisions, the dealer reveals their cards.</p>

                <p>The dealer's minimum qualifying hand is Two Twos.</p>

                <p>
                    If the dealer qualifies, their hand is compared to the players' hands. If the dealer does not qualify, only the Ante bet is paid 1:1. If the player's hand is stronger than the dealer's, the Ante bet is paid 1:1, and the Bet is paid according to the payout table.
                </p>

                <p>If the player's hand is weaker than the dealer's, the Ante and Bet are lost.</p>

                <p>The maximum payout is the highest amount payable for a single combination.</p>

                <p>Payout Table</p>
                <table className="rules-table">
                    <tbody>
                        <tr>
                            <td>Pair</td>
                            <td>1:1</td>
                        </tr>
                        <tr>
                            <td>Two Pairs</td>
                            <td>2:1</td>
                        </tr>
                        <tr>
                            <td>Three of a Kind</td>
                            <td>3:1</td>
                        </tr>
                        <tr>
                            <td>Straight</td>
                            <td>4:1</td>
                        </tr>
                        <tr>
                            <td>Flush</td>
                            <td>5:1</td>
                        </tr>
                        <tr>
                            <td>Full House</td>
                            <td>7:1</td>
                        </tr>
                        <tr>
                            <td>Four of a Kind</td>
                            <td>15:1</td>
                        </tr>
                        <tr>
                            <td>Straight Flush</td>
                            <td>35:1</td>
                        </tr>
                        <tr>
                            <td>Royal Flush</td>
                            <td>75:1</td>
                        </tr>
                        <tr>
                            <td>Poker</td>
                            <td>150:1</td>
                        </tr>
                    </tbody>
                </table>

                <p>In the event of identical hands, the winner is determined by the highest-ranking card in the poker hand, followed by the next highest cards. In a "Straight" 5-4-3-2-A, the Ace is the lowest card.</p>

                <p>In the event of complete identical hands, it is a "Stand off" (draw).</p>
            </div>


    },
    {
        id: 2,
        title: 'Poker Hands',
        content:
            <div className="rule-content">

                <p>- Individual cards are listed in descending order: Ace (high or low), King, Queen, Jack, 10, 9, 8, 7, 6, 5, 4, 3, and 2.
                    The Ace can be the highest card in a straight of Ace, King, Queen, Jack, and 10 or the lowest in a straight of 5, 4, 3, 2, and Ace.
                    Possible hands in descending order:</p>

                <p>Poker - a combination consisting of four cards of the same rank and a joker.</p>
                <div className="rules-combinations">
                    <div className="rules-combination">
                        <div className="rules-combination-text">5</div>
                        <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Spades" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">5</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Hearts" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">5</div>
                        <Picture src={`${env.mediapoint}/images/suits/diamond.png`} alt="Diamonds" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">5</div>
                        <Picture src={`${env.mediapoint}/images/suits/clubs.png`} alt="Clubs" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">+ Joker</div>
                    </div>
                </div>

                <p>Royal Flush - a straight flush consisting of Ace, King, Queen, Jack, and 10 of the same suit.</p>
                <div className="rules-combinations">
                    <div className="rules-combination">
                        <div className="rules-combination-text">10</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">J</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">Q</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">K</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">A</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                </div>

                <p>Straight Flush - a hand consisting of five consecutive cards of the same suit, for example: 10, 9, 8, 7, and 6, all hearts. Two straight flushes are compared by their highest card.</p>
                <div className="rules-combinations">
                    <div className="rules-combination">
                        <div className="rules-combination-text">6</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">7</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">8</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">9</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">10</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                </div>

                <p>Four of a Kind - a hand consisting of four cards of the same rank and any other card. For example, four fours. A four of a kind with higher-ranked cards beats one with lower-ranked cards.</p>
                <div className="rules-combinations">
                    <div className="rules-combination">
                        <div className="rules-combination-text">4</div>
                        <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Spade" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">4</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">4</div>
                        <Picture src={`${env.mediapoint}/images/suits/diamond.png`} alt="Diamond" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">4</div>
                        <Picture src={`${env.mediapoint}/images/suits/clubs.png`} alt="Club" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">A</div>
                        <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Spade" />
                    </div>
                </div>

                <p>Full House - a hand consisting of three cards of one rank and two cards of another rank, for example: three kings and two twos. The hand with the higher three of a kind is the winning full house.</p>
                <div className="rules-combinations">
                    <div className="rules-combination">
                        <div className="rules-combination-text">K</div>
                        <Picture src={`${env.mediapoint}/images/suits/diamond.png`} alt="Diamond" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">K</div>
                        <Picture src={`${env.mediapoint}/images/suits/clubs.png`} alt="Club" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">K</div>
                        <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Spade" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">2</div>
                        <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Spade" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">2</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                </div>

                <p>Flush - a hand consisting of any five cards of the same suit in any sequence, for example: five hearts. Two flushes are compared based on the highest card in each hand. If both hands have the same high card, the next highest card is compared, and so on, until a winner is determined. If all cards are the same, it's a tie.</p>
                <div className="rules-combinations">
                    <div className="rules-combination">
                        <div className="rules-combination-text">3</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">6</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">9</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">10</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">Q</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                </div>

                <p>Straight - a hand consisting of five consecutive cards of different suits, for example: Ace, 2, 3, 4, and 5 of mixed suits. Two straights are compared by their highest card. Straights with the same high card are of equal value, as suits are not considered in the comparison.</p>
                <div className="rules-combinations">
                    <div className="rules-combination">
                        <div className="rules-combination-text">A</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">2</div>
                        <Picture src={`${env.mediapoint}/images/suits/diamond.png`} alt="Diamond" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">3</div>
                        <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Spade" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">4</div>
                        <Picture src={`${env.mediapoint}/images/suits/clubs.png`} alt="Club" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">5</div>
                        <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Spade" />
                    </div>
                </div>

                <p>Three of a Kind - a hand consisting of three cards of the same rank and two other cards of different ranks, for example: three tens. The hand with higher-ranked cards wins.</p>
                <div className="rules-combinations">
                    <div className="rules-combination">
                        <div className="rules-combination-text">10</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">10</div>
                        <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Spade" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">10</div>
                        <Picture src={`${env.mediapoint}/images/suits/club.png`} alt="Club" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">K</div>
                        <Picture src={`${env.mediapoint}/images/suits/diamond.png`} alt="Diamond" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">3</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                </div>

                <p>Two Pairs - a hand consisting of two cards of one rank, two cards of another rank, and one other card of a different rank. The hand with the higher pair wins. If the high pairs are equal, the lower pairs are compared. If the lower pairs are also equal, the remaining card is compared to determine the winner.</p>
                <div className="rules-combinations">
                    <div className="rules-combination">
                        <div className="rules-combination-text">Q</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">Q</div>
                        <Picture src={`${env.mediapoint}/images/suits/diamond.png`} alt="Diamond" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">5</div>
                        <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Spade" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">5</div>
                        <Picture src={`${env.mediapoint}/images/suits/club.png`} alt="Club" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">K</div>
                        <Picture src={`${env.mediapoint}/images/suits/diamond.png`} alt="Diamond" />
                    </div>
                </div>

                <p>One Pair - a hand consisting of two cards of one rank and three other cards of different ranks. For example: two nines and any other three cards. The hand with the higher pair wins. If the pairs are equal, the highest of the other cards wins, and so on.</p>
                <div className="rules-combinations">
                    <div className="rules-combination">
                        <div className="rules-combination-text">9</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">9</div>
                        <Picture src={`${env.mediapoint}/images/suits/diamond.png`} alt="Diamond" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">A</div>
                        <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Spade" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">5</div>
                        <Picture src={`${env.mediapoint}/images/suits/clubs.png`} alt="Club" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">3</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                </div>

                <p>High Card - a hand that does not qualify under any of the above categories. The hand with the highest card wins. If the highest cards are the same, the second-highest card is compared, and so on.</p>
                <div className="rules-combinations">
                    <div className="rules-combination">
                        <div className="rules-combination-text">A</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">5</div>
                        <Picture src={`${env.mediapoint}/images/suits/diamond.png`} alt="Diamond" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">6</div>
                        <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Spade" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">J</div>
                        <Picture src={`${env.mediapoint}/images/suits/club.png`} alt="Club" />
                    </div>
                    <div className="rules-combination">
                        <div className="rules-combination-text">K</div>
                        <Picture src={`${env.mediapoint}/images/suits/heart.png`} alt="Heart" />
                    </div>
                </div>

            </div>
    },
    {
        id: 3,
        title: 'Bonus',
        type: 'bonus',
        content:
            <div className="rule-content">
                <p>The Bonus is an additional bet that the player can place.</p>
                <p>The Bonus bet wins if there is a combination of Three of a Kind or higher among the first five cards, and it is paid out according to the payout table. In all other cases, the Bonus bet loses.</p>
                <p>Payout Table</p>
                <table className="rules-table">
                    <tbody>
                        <tr>
                            <td>Three of a Kind</td>
                            <td>10:1</td>
                        </tr>
                        <tr>
                            <td>Straight</td>
                            <td>40:1</td>
                        </tr>
                        <tr>
                            <td>Flush</td>
                            <td>50:1</td>
                        </tr>
                        <tr>
                            <td>Full House</td>
                            <td>70:1</td>
                        </tr>
                        <tr>
                            <td>Four of a Kind</td>
                            <td>200:1</td>
                        </tr>
                        <tr>
                            <td>Straight Flush</td>
                            <td>1500:1</td>
                        </tr>
                        <tr>
                            <td>Royal Flush</td>
                            <td>5000:1</td>
                        </tr>
                    </tbody>
                </table>
            </div>
    },
    {
        id: 4,
        title: 'Place Bets',
        content:
            <div className="rule-content">

                <p>The "BET LIMITS" panel displays the minimum and maximum allowed betting limits at the table, which may change from time to time. Open "Bet Limits" to check your current limits.</p>

                <div className="rule-component">
                    <div className="game-info-inner">
                        <div className="game-info-text">J POKER</div>
                        <div className="game-info-rate">$ 1 - $ 1000</div>
                    </div>
                </div>

                <p>To participate in the game, you will need sufficient funds to cover your bets. Your current BALANCE is displayed on the screen.</p>
                <div className="rule-component">
                    <div className="balance-box">
                        <div className="balance-text">BALANCE:</div>
                        <div className="balance-value">$ 1,270</div>
                    </div>
                </div>

                <p>The "CHIP DISPLAY" indicator allows you to choose the denomination of each chip you want to place as a bet. Only chips with denominations that can be covered by your current balance are available for selection.</p>
                <div className="rule-component">
                    <div className="chips-container" style={{ transform: 'scale(0.4)' }}>

                        <div className="chips-button">
                            <Picture src={`${env.mediapoint}/images/delete.png`} alt="Delete" />
                            Clear
                        </div>

                        <div className="chips-button">
                            <Picture src={`${env.mediapoint}/images/cancel.png`} alt="Cancel" />
                            Cancel
                        </div>

                        <div className="chips-box">
                            {chips.map((chip, index) =>
                                <div key={`${index}`} className="chip">
                                    <Chip color={chip.color} value={chip.value} />
                                </div>
                            )}
                        </div>

                        <div className="chips-button">
                            <span>2x</span>
                            Double
                        </div>

                        <div className="chips-button">
                            <Picture src={`${env.mediapoint}/images/refresh.png`} alt="Refresh" />
                            Repeat
                        </div>

                    </div>
                </div>

                <p>After selecting a chip, place a bet by clicking on the corresponding betting spot on the game table. Each click on the betting spot increases your bet by the value of the selected chip or up to the maximum allowed limit for your chosen bet type. Once the maximum limit is reached, additional funds will not be accepted, and a message will appear notifying you that the maximum bet has been placed.</p>
                <div className="rule-component">
                    <div className="rates" style={{ position: "relative", top: 0, bottom: 0 }} >
                        <div className="bonus">
                            <div style={{ zIndex: 1 }} className="bonus-text">BONUS</div>
                        </div>
                        <div className="ante">
                            <div className="ante-text" style={{ zIndex: 1 }}>ANTE</div>
                        </div>
                        <div className="bet" style={{ opacity: 1 }}>
                            <div className="ante-text" style={{ zIndex: 1 }}>BET</div>
                        </div>
                    </div>
                </div>

                <p>NOTE: Please do not minimize your browser window or open other tabs while the betting time is active, and bets are being placed on the table. Such actions may be considered leaving the game, and your bets will be rejected for this game round.</p>

                <p>The "REPEAT" button allows you to repeat all bets from the previous game round. This button remains active until the first chip is placed.</p>

                <div className="rule-component">
                    <div className="chips-button">
                        <Picture src={`${env.mediapoint}/images/refresh.png`} alt="Refresh" />
                        Repeat
                    </div>
                </div>

                <p>The "DOUBLE" button (2×) becomes available after placing a bet. Each click doubles all your bets up to the maximum limit. Note that you must have sufficient funds in your account to double ALL your placed bets.</p>

                <div className="rule-component">
                    <div className="chips-button">
                        <span>2x</span>
                        Double
                    </div>
                </div>

                <p>The "CANCEL" button allows you to remove the last placed bet.</p>
                <p>Clicking the "CANCEL" button again allows you to remove bets one by one in reverse order of placement. To remove all your bets, hold down the "CANCEL" button.</p>
                <div className="rule-component">
                    <div className="chips-button">
                        <Picture src={`${env.mediapoint}/images/cancel.png`} alt="Cancel" />
                        Cancel
                    </div>
                </div>

                <p>The "CLEAR" button allows you to remove all placed bets.</p>
                <div className="rule-component">
                    <div className="chips-button">
                        <Picture src={`${env.mediapoint}/images/delete.png`} alt="Delete" />
                        Clear
                    </div>
                </div>

                <p>The "TOTAL BET" indicator displays the total amount of bets placed in the current round.</p>
                <div className="rule-component">
                    <div className="balance-box">
                        <div className="balance-text blue">TOTAL BET:</div>
                        <div className="balance-value">$ 270</div>
                    </div>
                </div>

                <p>Make a decision</p>
                <p>After your cards are dealt, your hand combination and a window will appear.</p>
                <div className="rule-component">
                    <Picture src="/rules/game.png" alt="Game" />
                </div>

                <p>To Exchange, click on the cards you want to replace and press the EXCHANGE window.</p>
                <div className="rule-component">
                    <Exchange />
                </div>

                <p>You must decide whether to click "BET" to continue the game round or "FOLD" to end the round, losing the placed bets.</p>
                <div className="rule-component">
                    <Bet />
                    <Fold />
                </div>

                <p>Clicking the "BET" button continues the game, and a "BET" wager is automatically placed on the "BET" spot.</p>

                <p>Clicking the "FOLD" button results in the loss of your ANTE bet.</p>
            </div>

    },
    {
        id: 5,
        title: 'Game Number',
        content:
            <div className="rule-content">
                <p>Each game round is identified by a unique GAME NUMBER.</p>
                <div className="rule-component">
                    <p><b>#47489</b></p>
                </div>
                <p>Please use this number (or take a screenshot of the game number) if you wish to contact Support with questions regarding a specific round.</p>
            </div>
    },
    {
        id: 6,
        title: 'Sound',
        content:
            <div className="rule-content">
                <p>The "SOUND" button toggles all game sounds and voices on or off. Please note that changing tables will automatically turn sounds back on.</p>

                <div className="rule-component">
                    <div className="game-control">
                        <Picture src={`${env.mediapoint}/images/music-on.png`} alt="Volume" />
                    </div>
                    <div className="game-control">
                        <Picture src={`${env.mediapoint}/images/volume.png`} alt="Volume" />
                    </div>
                </div>

                <p>You can adjust sound settings by pressing the "SETTINGS" button and selecting the SOUND tab.</p>
            </div>
    },
    {
        id: 7,
        title: 'Game History',
        content:
            <div className="rule-content">
                <p>The "HISTORY" button opens a window displaying all the game rounds you have played and their results.</p>

                <div className="rule-component">
                    <div className="game-control">
                        <Picture src={`${env.mediapoint}/images/history.png`} alt="History" />
                    </div>
                </div>

                <p>The information in the History window is for reference purposes only and may not reflect the final balance due to technical issues.</p>
            </div>
    },
    {
        id: 8,
        title: 'Actions in Case of Malfunction',
        content:
            <div className="rule-content">
                <p>
                    In the event of a game, system, or procedural malfunction, the round will be temporarily
                    suspended, and the game host will notify the service manager. You and other players
                    will see a message in the chat or a pop-up message on the screen informing you that the
                    issue is being addressed. If the manager is able to fix the issue immediately, the game round
                    will resume as normal. If immediate resolution is not possible, the game round will be
                    canceled, and the initial bets will be refunded to all participating players.
                </p>
            </div>
    },
    {
        id: 9,
        title: 'Disconnection Policy',
        content:
            <div className="rule-content">
                <p>
                    If you are disconnected from the game before the betting time expires, any placed bets
                    will be considered invalid and refunded to you. If disconnection occurs after the betting time
                    has expired, placed bets will remain valid and the game will proceed without your participation.
                    You can view the results of the bet in the "History" window after reconnecting.
                </p>
            </div>
    }
]

export const rules = { ru, en }